import { useState, useRef } from 'react';
import { HiOutlineChevronUp, HiOutlineChevronDown } from 'react-icons/hi';
import Embedded from '../images/Embedded.svg';
import Wireless from '../images/Wireless.svg';
import Security from '../images/Security.svg';
import Capabilities from '../images/TechCapabilities.svg';

const TechCapabilities = () => {

//Dropdown content of How we help section
const [isOpen, setIsOpen] = useState(false);

const toggleSection = (section) => {
setIsOpen((prev) => ({
    ...prev,
    [section]: !prev[section],
}));
};
const contentRef = useRef(null);

    return (
        <>
        <div className='py-14 sm:pt-32 xl:pt-36 bg-gradient-to-t from-[#CACDE5] to-[#FFFFFF]'>

            <div className='flex flex-col items-center mb-8'>
                <h1 className='text-[var(--kaizekblue)] font-uiBold text-4xl xl:text-5xl'>Technical Capabilities</h1>
                <p className='text-[var(--lightgray)] font-symbol text-xl lg:text-2xl text-center my-4'>Our core technical expertise and competencies</p>
            </div>

            <div className='flex flex-col lg:flex-row xl:w-10/12 2xl:w-8/12 m-auto'>

                <div className='mx-4 lg:mx-12 flex justify-center'>
                    <img src={Capabilities} alt="Technical Capabilities" />
                </div>

                <div className='pt-8 lg:pt-16 xl:w-8/12 mx-4 sm:mx-10 lg:mx-12 grid grid-flow-row gap-4 lg:gap-8'>
                    {/* 0.625 10px border */}
                    <div className="rounded-xl bg-white p-3 sm:p-6 border-l-[0.4rem] border-[var(--coolgray)] shadow-lg cursor-pointer"
                        onClick={() => toggleSection('embeddedSystems')}
                        aria-expanded={isOpen['embeddedSystems']}
                        aria-controls="embeddedSystems-content"
                        role="button"
                        aria-label="Toggle Embedded Systems Section">
                        <div className='flex-row flex justify-between'>
                            <div className='flex flex-row items-center'>
                                <img src={Embedded} alt="Embedded Systems"></img>
                                <h2 className="font-uiSemilight text-xl sm:text-2xl xl:text-[1.75rem] text-[var(--darkgray)] px-6 xl:px-8">Embedded Systems</h2>
                            </div>
                            <div className="items-center flex">
                            <span>{isOpen['embeddedSystems'] ? <HiOutlineChevronUp className='text-[var(--kaizekblue)]' size={20} style={{ strokeWidth: 3 }} /> : <HiOutlineChevronDown className='text-[var(--kaizekblue)]' size={20} style={{ strokeWidth: 3 }} />}</span>
                            </div>
                        </div>
                        <div id="embeddedSystems-content" ref={contentRef}
                            style={{
                                maxHeight: isOpen['embeddedSystems']
                                ? `${contentRef.current?.scrollHeight}px`
                                : "0px",
                            }}
                            className={`transition-max-height duration-500 ease-in-out overflow-hidden px-2 lg:px-4 ${
                                            isOpen["embeddedSystems"] ? "max-h-screen" : "max-h-0"}`}>
                            <ul className="text-[var(--lightgray)] ps-3 list-outside list-disc text-base lg:text-[1.25rem] my-6 space-y-1 lg:space-y-2">
                                <li>Real-time performance & power-efficient designs</li>
                                <li>Optimized memory & device driver development</li>
                                <li>Scalable solutions for diverse applications</li>
                            </ul>
                        </div>
                    </div>

                    <div className="rounded-xl bg-white p-3 sm:p-6 border-l-[0.4rem] border-[var(--coolgray)] shadow-lg cursor-pointer"
                        onClick={() => toggleSection('wirelessTechnologies')}
                        aria-expanded={isOpen['wirelessTechnologies']}
                        aria-controls="wirelessTechnologies-content"
                        role="button"
                        aria-label="Toggle Wireless Technologies Section">
                        <div className='flex-row flex justify-between'>
                            <div className='flex flex-row items-center'>
                                <img src={Wireless} alt="Wireless Technologies"></img>
                                <h2 className="font-uiSemilight text-xl sm:text-2xl xl:text-[1.75rem] text-[var(--darkgray)] px-6 xl:px-8">Wireless Technologies</h2>
                            </div>
                            <div className="items-center flex">
                            <span>{isOpen['wirelessTechnologies'] ? <HiOutlineChevronUp className='text-[var(--kaizekblue)]' size={20} style={{ strokeWidth: 3 }} /> : <HiOutlineChevronDown className='text-[var(--kaizekblue)]' size={20} style={{ strokeWidth: 3 }} />}</span>
                            </div>
                        </div>
                        <div id="wirelessTechnologies-content" ref={contentRef}
                            style={{
                                maxHeight: isOpen['wirelessTechnologies']
                                ? `${contentRef.current?.scrollHeight}px`
                                : "0px",
                            }}
                            className={`transition-max-height duration-500 ease-in-out overflow-hidden px-2 lg:px-4 ${
                                            isOpen["wirelessTechnologies"] ? "max-h-screen" : "max-h-0"}`}>
                            <ul className="text-[var(--lightgray)] ps-3 list-outside list-disc text-base lg:text-[1.25rem] my-6 space-y-1 lg:space-y-2">
                                <li>Seamless connectivity with advanced RF protocols</li>
                                <li>Expertise in LoRaWAN, Bluetooth LE, Wi-Fi, and NB-IoT</li>
                                <li>Reliable wireless solutions for dynamic environments</li>
                            </ul>
                        </div>
                    </div>

                    <div className="rounded-xl bg-white p-3 sm:p-6 border-l-[0.4rem] border-[var(--coolgray)] shadow-lg cursor-pointer"
                        onClick={() => toggleSection('securityCompliance')}
                        aria-expanded={isOpen['securityCompliance']}
                        aria-controls="securityCompliance-content"
                        role="button"
                        aria-label="Toggle Security & Compliance Section">
                        <div className='flex-row flex justify-between'>
                            <div className='flex flex-row items-center'>
                                <img src={Security} alt="Security & Compliance"></img>
                                <h2 className="font-uiSemilight text-xl sm:text-2xl xl:text-[1.75rem] text-[var(--darkgray)] px-6 xl:px-8">Security & Compliance</h2>
                            </div>
                            <div className="items-center flex">
                            <span>{isOpen['securityCompliance'] ? <HiOutlineChevronUp className='text-[var(--kaizekblue)]' size={20} style={{ strokeWidth: 3 }} /> : <HiOutlineChevronDown className='text-[var(--kaizekblue)]' size={20} style={{ strokeWidth: 3 }} />}</span>
                            </div>
                        </div>
                        <div id="securityCompliance-content" ref={contentRef}
                            style={{
                                maxHeight: isOpen['securityCompliance']
                                ? `${contentRef.current?.scrollHeight}px`
                                : "0px",
                            }}
                            className={`transition-max-height duration-500 ease-in-out overflow-hidden px-2 lg:px-4 ${
                                            isOpen["securityCompliance"] ? "max-h-screen" : "max-h-0"}`}>
                            <ul className="text-[var(--lightgray)] ps-3 list-outside list-disc text-base lg:text-[1.25rem] my-6 space-y-1 lg:space-y-2">
                                <li>End-to-end system security with secure boot & encryption</li>
                                <li>Compliance with industry security standards</li>
                                <li>Certification-ready solutions with rigorous testing</li>
                            </ul>
                        </div>
                    </div>
                    {/* Dropdown section ends */}
                </div>
            </div>
        </div>
        {/* Tech Capabilities section ends */}
        </>
    )
}

export default TechCapabilities